import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./apiClient";

/**
 * Sdílený React Query klient. Neretryuje 4xx (klientská chyba / auth) — jen
 * síťové/5xx jednou. Data považujeme za čerstvá 30 s (admin UI, ne realtime).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});
